import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const shiftService = {
  getList,
  create,
  createBulk,
  update,
  destroy,
};

function getList(propertyId, weekStart) {
  return axios
    .get(apiEndpoint.shifts, {
      headers: authHeader(),
      params: { property_id: propertyId, week_start: weekStart },
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { shifts: [] };
    });
}

function create(data) {
  return axios
    .post(apiEndpoint.shifts, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Create a recurring series of shifts. `data.dates` is the array of
// occurrence dates (YYYY-MM-DD) computed client-side.
function createBulk(data) {
  return axios
    .post(`${apiEndpoint.shifts}/bulk`, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function update(id, data) {
  return axios
    .put(apiEndpointFunction.shifts(id), data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.shifts(id), { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
